<template>
	<div class="relative min-h-screen flex items-start justify-center overflow-hidden bg-[#FFF2E0] pt-20 p-4">
		<!-- bg animation -->
		<div class="absolute inset-0 z-0 pointer-events-none">
			<div class="absolute inset-0 animated-gradient"></div>
			<div class="blob blob-1"></div>
			<div class="blob blob-2"></div>
		</div>

		<div class="relative z-10 bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden mt-20">
			<!-- header -->
			<div class="sticky top-0 bg-white px-8 pt-8 pb-4 border-b border-gray-200">
				<div class="flex flex-col items-center space-y-4">
					<img :src="(currentTheme === 'dark' || currentTheme === 'navy')? lightLogo: lightLogo" alt="Logo" class="w-32 md:w-40"/>
					<h1 class="text-2xl font-archivomedium text-gray-800">
						Reset Your Password
					</h1>
				</div>
			</div>

			<!-- form -->
			<div class="px-8 py-6">
				<form @submit.prevent="submit" novalidate class="space-y-5">
					<div>
						<label class="block text-sm text-gray-700 mb-1">New Password</label>
						<input v-model="form.password" type="password" placeholder="••••••••" class="w-full px-4 py-2 rounded-lg bg-gray-50 border border-gray-300
						focus:outline-none focus:ring-1 focus:ring-[#FC9984] transition"/>
					</div>
					<div>
						<label class="block text-sm text-gray-700 mb-1">Confirm Password</label>
						<input v-model="form.confirmPassword" type="password" placeholder="••••••••" class="w-full px-4 py-2 rounded-lg bg-gray-50 border border-gray-300
						focus:outline-none focus:ring-1 focus:ring-[#FC9984] transition"/>
					</div>
					<div class="flex items-center justify-between">
						<a href="#" @click.prevent="$emit('cancel')" class="text-sm text-[#FC9984] hover:underline">
							Back to Login
						</a>
						<button type="submit" :disabled="loading" class="px-6 py-2 rounded-full bg-[#FC9984] text-white font-archivomedium
							border border-[#FC9984] hover:bg-transparent hover:text-[#FC9984] transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center">
							<span v-if="!loading">
								Submit
							</span>
							<div v-else class="loader w-5 h-5"></div>
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { reactive } from 'vue';
	import lightLogo from '../assets/CWWLogo.png';
	import darkLogo  from '../assets/LogoWhite1.png';

	const props = defineProps({
		currentTheme: String,
		token: String,
		loading: Boolean
	});

	const emit = defineEmits(['reset-password','cancel','validation-error']);

	const form = reactive({ password:'', confirmPassword:'' });

	function submit() {
		if (!form.password || !form.confirmPassword) {
			emit('validation-error','Please fill both fields.');
			return;
		}
		if (form.password !== form.confirmPassword) {
			emit('validation-error','Passwords do not match.');
			return;
		}
		emit('reset-password', {
			token: props.token,
			password: form.password,
			confirmPassword: form.confirmPassword
		});
	}
</script>

<style scoped>
	.loader {
		border: 4px solid #f3f3f3;
		border-top: 4px solid #FC9984;
		border-radius: 50%;
		width: 1rem;
		height: 1rem;
		animation: spin 1s linear infinite;
	}
	@keyframes spin { to { transform: rotate(360deg) } }

	.animated-gradient {
		position:absolute; inset:0;
		background: linear-gradient(60deg, #FFF2E0, #FFEFD9 ,#FFE0E2,);
		background-size: 300% 300%;
		animation: moveGrad 10s ease infinite;
		filter: blur(100px);
		opacity: 0.6;
	}

	.blob {
		position:absolute; border-radius:50%; filter: blur(80px); opacity:0.7;
	}
	.blob-1 {
		width:300px; height:300px; background:#FFCEB0;
		top:-80px; left:-60px;
		animation: float1 20s ease-in-out infinite;
	}
	.blob-2 {
		width:250px; height:250px; background:#FFEFD9;
		bottom:-60px; right:-40px;
		animation: float2 18s ease-in-out infinite;
	}

	@keyframes moveGrad {
		0%{background-position:0% 50%}
		50%{background-position:100% 50%}
		100%{background-position:0% 50%}
	}
	@keyframes float1 {
		0%,100%{transform:translate(0,0) scale(1)}
		50%{transform:translate(40px,-30px) scale(1.1)}
	}
	@keyframes float2 {
		0%,100%{transform:translate(0,0) scale(1)}
		50%{transform:translate(-30px,20px) scale(0.9)}
	}
	@keyframes drift1 {
		0%{transform:translate(0,0)}
		100%{transform:translate(-120px,120px)}
	}
	@keyframes drift2 {
		0%{transform:translate(0,0)}
		100%{transform:translate(100px,-100px)}
	}
</style>
